var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"avatar",attrs:{"cover":"","src":require('@/assets/images/idle_carey.gif')},on:{"error":function($event){return _vm.onImageError()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }